import Modal from './modal';
import { getVideoEmbedURL } from '../util/video-url';

const VIDEO_ICON_SVG = `
	<svg xmlns="http://www.w3.org/2000/svg" class="modal-video-playlist__item-icon" width="20" height="20" viewBox="0 0 20 20">
		<path d="M10,2.23606798 L18.381966,19 L1.61803399,19 L10,2.23606798 Z" transform="translate(10.000000, 10.000000) rotate(-270.000000) translate(-10.000000, -10.000000) " fill="#FFFFFF" stroke="#0365B7" stroke-width="2"></path>
	</svg>
`.trim();

class ModalVideoPlaylist {
	constructor(el) {
		this.el = el;

		this.initializeModal();
	}

	initializeModal = () => {
		this.el.addEventListener('click', (e) => {
			e.preventDefault();

			let playlist = [];

			try {
				playlist = JSON.parse(this.el.getAttribute('data-video-playlist') || '[]');
			} catch (err) {
				playlist = [];
			}

			if (!playlist.length) {
				return;
			}

			this.showPlaylistModal(playlist, 0);
		});
	};

	showPlaylistModal = (playlist, activeIndex) => {
		Modal.show('', {
			modalClass: 'modal modal-video-playlist'
		});

		Modal.setContent(this.renderContent(playlist, activeIndex), false);

		const contentEl = document.querySelector('.modal-video-playlist .modal__content');

		this.setActiveItem(contentEl, playlist, activeIndex, true);

		contentEl.querySelectorAll('.modal-video-playlist__item').forEach((itemEl) => {
			itemEl.addEventListener('click', (e) => {
				e.preventDefault();

				const index = parseInt(itemEl.getAttribute('data-index'), 10);

				this.setActiveItem(contentEl, playlist, index);
			});
		});
	};

	setActiveItem = (contentEl, playlist, index, isFirstLoad = false) => {
		const item = playlist[index];

		if (!item) {
			return;
		}

		contentEl.querySelectorAll('.modal-video-playlist__item').forEach((itemEl) => {
			itemEl.classList.toggle(
				'is-active',
				parseInt(itemEl.getAttribute('data-index'), 10) === index
			);
		});

		if (isFirstLoad) {
			Modal.setLoading(true);
		}

		const playerEl = contentEl.querySelector('.modal-video-playlist__player');
		const embedUrl = getVideoEmbedURL(`https://www.youtube.com/watch?v=${item.videoId}`);

		playerEl.classList.add('is-loading');

		playerEl.innerHTML = `
			<div class="modal-video-playlist__player-loading">
				<div class="ui__spin-loader"></div>
			</div>
			<div class="modal__video-container">
				<iframe class="modal__video-embed"
					src="${embedUrl}"
					frameborder="0"
					allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
					allowfullscreen>
				</iframe>
			</div>
		`;

		const iframeEl = playerEl.querySelector('.modal__video-embed');

		iframeEl.addEventListener('load', () => {
			playerEl.classList.remove('is-loading');

			if (isFirstLoad) {
				Modal.setLoading(false);
			}
		});
	};

	renderContent = (playlist, activeIndex) => `
		<div class="modal-video-playlist__container">
			<ul class="modal-video-playlist__list">
				${playlist.map(
						(item, index) => `
					<li class="modal-video-playlist__item${index === activeIndex ? ' is-active' : ''}" data-index="${index}">
						${VIDEO_ICON_SVG}
						<span class="modal-video-playlist__item-label">${item.label}</span>
					</li>
				`
					)
					.join('')}
			</ul>
			<div class="modal-video-playlist__player"></div>
		</div>
	`;
}

export default ModalVideoPlaylist;
